import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, Flame, TrendingUp } from 'lucide-react';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState({
    m: '15',
    s: '00'
  });
  const [progress, setProgress] = useState(70);
  useEffect(() => {
    const saved = localStorage.getItem('urgency_end');
    let end: number;
    if (saved) {
      end = parseInt(saved, 10);
    } else {
      end = Date.now() + 15 * 60 * 1000;
      try {
        localStorage.setItem('urgency_end', end.toString());
      } catch (e) {}
    }
    const update = () => {
      const diff = Math.max(0, end - Date.now());
      const m = Math.floor(diff / 60000);
      const s = Math.floor(diff % 60000 / 1000);
      setTimeLeft({
        m: String(m).padStart(2, '0'),
        s: String(s).padStart(2, '0')
      });
    };
    update();
    const interval = setInterval(update, 1000);
    // Progress bar creeps from 70% upward slowly to reinforce scarcity
    const progInterval = setInterval(() => {
      setProgress(p => p < 88 ? +(p + 0.15).toFixed(2) : p);
    }, 2000);
    return () => {
      clearInterval(interval);
      clearInterval(progInterval);
    };
  }, []);
  return <div className="w-full max-w-[640px] mx-auto mb-5 sm:mb-7" data-id="element-377">
      <motion.div animate={{
      boxShadow: ['0 6px 24px rgba(225,29,72,0.35)', '0 8px 34px rgba(225,29,72,0.55)', '0 6px 24px rgba(225,29,72,0.35)']
    }} transition={{
      duration: 1.6,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#E11D48] via-[#C81E5A] to-rosa-oscuro text-white p-3 sm:p-4 border border-white/15" data-id="element-378">
        {/* Header row: live pulse + headline + timer */}
        <div className="flex items-center gap-2.5 sm:gap-3" data-id="element-379">
          <div className="relative flex-shrink-0" data-id="element-380">
            <motion.div animate={{
            scale: [1, 1.15, 1]
          }} transition={{
            duration: 1,
            repeat: Infinity
          }} className="w-9 h-9 sm:w-11 sm:h-11 rounded-full bg-white/15 flex items-center justify-center" data-id="element-381">
              <Flame size={18} className="text-yellow-300 fill-yellow-300/40" data-id="element-382" />
            </motion.div>
          </div>

          <div className="flex-1 min-w-0 text-left" data-id="element-383">
            <div className="flex items-center gap-1.5 mb-0.5" data-id="element-384">
              <span className="inline-flex items-center gap-1 bg-black/25 rounded-full px-2 py-0.5 text-[9px] sm:text-[10px] font-bold uppercase tracking-wider" data-id="element-385">
                <span className="w-1.5 h-1.5 rounded-full bg-yellow-300 animate-pulse" data-id="element-386" />
                Oferta por tiempo limitado
              </span>
            </div>
            <p className="text-[11px] sm:text-[13px] font-bold leading-tight" data-id="element-387">
              Cuando se agoten los cupos, el precio sube{' '}
              <span className="text-yellow-300" data-id="element-388">$10.000</span> y{' '}
              <span className="underline decoration-yellow-300" data-id="element-389">
                no vuelve a bajar.
              </span>
            </p>
          </div>

          {/* Timer */}
          <div className="flex-shrink-0 flex items-center gap-1.5 bg-black/30 rounded-xl px-2.5 sm:px-3 py-1.5 sm:py-2" data-id="element-390">
            <Clock size={14} className="text-yellow-300 hidden sm:block" data-id="element-391" />
            <div className="font-mono font-black text-[18px] sm:text-[22px] leading-none tabular-nums tracking-tight" data-id="element-392">
              {timeLeft.m}:{timeLeft.s}
            </div>
          </div>
        </div>

        {/* Progress bar starting at 70% */}
        <div className="mt-2.5 sm:mt-3" data-id="element-393">
          <div className="flex items-center justify-between text-[9px] sm:text-[11px] font-semibold mb-1" data-id="element-394">
            <span className="flex items-center gap-1 text-white/90" data-id="element-395">
              <TrendingUp size={12} className="text-yellow-300" data-id="element-396" /> Cupos casi
              agotados
            </span>
            <span className="text-yellow-300 font-bold" data-id="element-397">
              {Math.round(progress)}%
            </span>
          </div>
          <div className="h-2.5 sm:h-3 w-full rounded-full bg-black/30 overflow-hidden" data-id="element-398">
            <motion.div initial={{
            width: '70%'
          }} animate={{
            width: `${progress}%`
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="relative h-full rounded-full bg-gradient-to-r from-yellow-300 to-amber-400" data-id="element-399">
              <motion.div animate={{
              x: ['-100%', '250%']
            }} transition={{
              duration: 1.8,
              repeat: Infinity,
              ease: 'linear'
            }} className="absolute inset-y-0 w-1/3 bg-white/40 blur-sm" data-id="element-400" />
            </motion.div>
          </div>
        </div>
      </motion.div>
    </div>;
}